/*
 * cart-rewards: <cart-upsells> analytics. Rendering and the rules engine are in snippets/cart-upsells.liquid and
 * quick-add is Prestige's own product-form / quick-buy, so this file only reports:
 *   upsell_viewed - upsells were visible in an open drawer (once per drawer opening per rule + product set)
 *   upsell_added  - a product was added from an upsell card (directly or through its quick-buy panel)
 */
(() => {
  const CR = window.CartRewards;
  if (!CR || window.customElements.get('cart-upsells')) return;

  let lastViewed = '';

  class CartUpsells extends HTMLElement {
    connectedCallback() {
      if (this.getAttribute('data-analytics') === 'true') CR.analyticsEnabled = true;
      this.drawer = this.closest('cart-drawer');
      if (this.drawer?.hasAttribute('open')) this.reportView();
    }

    reportView() {
      const signature = `${this.dataset.rule}|${this.dataset.products}`;
      if (signature === lastViewed) return;
      lastViewed = signature;
      CR.track('upsell_viewed', { rule: this.dataset.rule, products: (this.dataset.products || '').split(',').filter(Boolean) });
    }
  }

  // The drawer element persists across re-renders; its children (including <cart-upsells>) are replaced.
  document.addEventListener('dialog:after-show', (event) => { // capture: dialog events don't bubble
    if (event.target?.matches?.('cart-drawer')) event.target.querySelector('cart-upsells')?.reportView();
  }, true);
  document.addEventListener('dialog:after-hide', (event) => {
    if (event.target?.matches?.('cart-drawer')) lastViewed = '';
  }, true);

  // Remember an add-to-cart submitted from an upsell card (or its quick-buy panel), then report it once the theme
  // confirms the add with `cart:change`. (The theme's own `variant:add` can fire on a form that a drawer refresh
  // has already detached, so it can't be relied on here.)
  let pendingAdd = null;

  // Prestige moves an open quick-buy modal to <body>, so tag it with the rule just before it moves.
  document.addEventListener('dialog:before-show', (event) => {
    const upsells = event.target?.matches?.('quick-buy-modal') && event.target.closest('cart-upsells');
    if (upsells) event.target.setAttribute('data-cart-upsells-rule', upsells.dataset.rule);
  }, true);

  document.addEventListener('submit', (event) => {
    const form = event.target;
    const rule = form?.closest?.('cart-upsells')?.dataset.rule || form?.closest?.('[data-cart-upsells-rule]')?.getAttribute('data-cart-upsells-rule');
    if (!rule) return;
    pendingAdd = { rule, variantId: Number(new FormData(form).get('id')) || null, at: Date.now() };
  }, true);

  document.addEventListener('cart:change', (event) => {
    if (!pendingAdd || event.detail?.baseEvent !== 'variant:add' || Date.now() - pendingAdd.at > 15000) return;
    const item = event.detail.cart?.items?.find((line) => line.variant_id === pendingAdd.variantId) || {};
    CR.track('upsell_added', {
      rule: pendingAdd.rule,
      variant_id: pendingAdd.variantId,
      product_id: item.product_id,
      product_handle: item.handle
    });
    pendingAdd = null;
  });

  window.customElements.define('cart-upsells', CartUpsells);
})();
